import { initializeApp } from "firebase/app";
import { devConfig, stagingConfig, productionConfig } from "./config";
import useAuth from "./auth";
import { useAnalytics } from "./analytics";
import { getStorage } from "firebase/storage";

// Select config based on environment
let config = devConfig;
switch (import.meta.env.VITE_USER_ENVIRONMENT) {
  case "production":
    console.info("Environment: Production");
    config = productionConfig;
    break;
  case "test":
    console.info("Environment: Staging");
    config = stagingConfig;
    break;
  default:
    console.info("Environment: Development");
}

// Initialize Firebase
const app = initializeApp(config);

// Initialize Firebase Analytics
const analytics = useAnalytics(app);

// Initialize Firebase Auth
const auth = useAuth(app, analytics);

// Initialize Firebase Storage
const storage = getStorage(app);

export { analytics, auth, storage };
